import { render, staticRenderFns } from "./KeFu.vue?vue&type=template&id=962d67fc&scoped=true&"
import script from "./KeFu.vue?vue&type=script&lang=js&"
export * from "./KeFu.vue?vue&type=script&lang=js&"
import style0 from "./KeFu.vue?vue&type=style&index=0&id=962d67fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962d67fc",
  null
  
)

export default component.exports